import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './quoteform.css';
import { GoArrowRight } from "react-icons/go";

const Quoteform = () => {
  // Initialize the selectedOption state using useState
  const [selectedOption, setSelectedOption] = useState("");
  const form = useRef();
  const [status, setStatus] = useState('');


  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_k9vz6ab',      // Replace with your EmailJS Service ID
      'template_y0ldz2p',     // Replace with your Template ID
      form.current,
      'nVxbd2XcWHQ9AG6fm'       // Replace with your Public Key
    ).then(
      () => {
        setStatus('✅ Quotation request sent successfully!');
        form.current.reset();
        setSelectedOption('');
      },
      (error) => {
        setStatus('❌ Failed to send. Try again.');
        console.error(error);
      }
    );
  };


  

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value); // Update the state when option changes
  };

  

  return (
    <div className='quoteform'>
      {status && <p style={{ textAlign: "center", marginTop: "1rem" }}>{status}</p>}
      <h3>GET A FREE QUOTATION</h3>
      <form ref={form} onSubmit={sendEmail}>
        <input type="text" placeholder='Enter your name' name="user_name" className='inputfeild' required/>
        <input type="number" placeholder='Enter your WhatsApp number'  name="user_whatsapp" className='inputfeild' required/>
        <input type="email" placeholder='Enter your email ID' name="user_email" className='inputfeild' />
        <input type="text" placeholder='Enter your city or town'  name="user_city" className='inputfeild'/>
       
        <select
          id="options"
          value={selectedOption}
          name="user_service"
          onChange={handleSelectChange}
          required
        >
          {/* This will act as the placeholder */}
          <option value="" disabled>Service Required</option>
          <option value="Home Interiors">Home Interiors</option>
          <option value="Modular Kitchen">Modular Kitchen</option>
          <option value="Office/Commercial Interiors">Office/Commercial Interiors</option>
          <option value="Custom Interior Units">Custom Interior Units (e.g., study tables, storage units, TV units)</option>
          <option value="Custom Packages">Custom Packages (e.g., 2BHK, 3BHK)</option>
        </select>

        <button className='submit'>
          Get Quotation<span>{<GoArrowRight />}</span>
        </button>
      </form>
    </div>
  );
}

export default Quoteform;